import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/game/page.tsx");
